import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup.SectionSecurity.EmailChangeViaSupportPopup', {
    title: 'Please change my email to',
    subtitle: 'Please double-check your new email address.',
    description: `Make sure the email you entered is correct. If it's incorrect, you may lose access to your account or important notifications.`,
    buttonSend: 'Send',
    fieldEmailLabel: 'New email',
    fieldEmailPlaceholder: 'Enter new email',
});
